import React from 'react';
import { SelectProps, Flex, Checkbox, FormControl } from '@cad-arc';
import {
    LongValueOption,
    SubdivisionOption,
    MapUnitStatusOption,
    DispatchAreaOption,
    AgencyProfileOption,
} from '@mark43/cad-api';
import { BaseSelect } from '../../forms/inputs/base-select';
import { Controller, useFormContext } from 'react-hook-form';
import { FilterOption } from '../types';

interface EsriMapMultiselectFieldProps extends Omit<SelectProps, 'ref' | 'name'> {
    label: string;
    name: string;
    options:
        | FilterOption[]
        | LongValueOption[]
        | SubdivisionOption[]
        | MapUnitStatusOption[]
        | DispatchAreaOption[]
        | AgencyProfileOption[];
}

export const EsriMapMultiselectField = ({
    label,
    name,
    ...props
}: EsriMapMultiselectFieldProps) => {
    const { control, setValue, watch } = useFormContext();

    const { options } = props;
    const inputId = `${name}Id`;

    const handleCheckbox = () => {
        const values = options?.map((option) => option.value);
        setValue(name, ifAllWereSelected ? [] : values);
    };

    const ifAllWereSelected = watch(name)?.length === options?.length;

    return (
        <Flex flexDirection="column" width="100%">
            <Flex justifyContent="end" width="100%">
                <Checkbox
                    style={{ width: '100px' }}
                    isChecked={ifAllWereSelected}
                    onChange={handleCheckbox}
                    data-testid={`MAP_FILTERS_${name}_SELECT_ALL_CHECKBOX`}
                >
                    Select All
                </Checkbox>
            </Flex>
            <Controller
                name={name}
                control={control}
                render={({ field }) => {
                    return (
                        <FormControl label={label} htmlFor={inputId}>
                            <BaseSelect
                                data-testid={`MAP_FILTERS_${name}_MULTISELECT`}
                                isMultiple
                                inputId={inputId}
                                truncateSelectedCount={2}
                                {...field}
                                {...props}
                            />
                        </FormControl>
                    );
                }}
            />
        </Flex>
    );
};
